import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={158}
    height={171}
    preserveAspectRatio="xMidYMid meet"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    fill="none"
    {...props}
  >
    <g opacity={0.2}>
      <mask
        id="a"
        width={67}
        height={45}
        x={91}
        y={63}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M157.658 63.167H91.169v44.415h66.489V63.168Z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          d="m153.852 83.65-1.233-.672c3.108-1.82 4.983-5.032 5.032-8.653.05-3.731-1.844-7.08-5.063-8.962-4.854-2.83-10.942-2.923-15.882-.24l-8.438 4.582-3.115-1.702a5.272 5.272 0 0 0-4.872-.093L94.092 80.944c-3.75 1.869-3.928 7.148-.314 9.264 9.017 5.274 22.741 13.347 28.366 16.653a5.287 5.287 0 0 0 5.137.117l26.522-14.038c3.713-1.967 3.744-7.271.055-9.282m-14.969-14.525a11.684 11.684 0 0 1 11.392.172 5.558 5.558 0 0 1 2.794 4.947 5.595 5.595 0 0 1-2.936 4.873c-.962.524-1.715.93-2.301 1.245l-14.796-8.067 5.841-3.17h.006Z"
        />
      </g>
    </g>
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m128.311 41.944-31.72-17.936a2.465 2.465 0 0 0-2.634.118l-12.354 7.13 11.28 11.626v22.92c0 .9.488 1.732 1.278 2.17l16.338 9.067 8.135 17.374 12.613-7.234s.025-.013.031-.019l.074-.043a2.465 2.465 0 0 0 1.141-2.09V49.11a8.23 8.23 0 0 0-4.188-7.173"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m128.311 41.944-31.72-17.936a2.465 2.465 0 0 0-2.634.118l-12.354 7.13 11.28 11.626v22.92c0 .9.488 1.732 1.278 2.17l16.338 9.067 8.135 17.374 12.613-7.234s.025-.013.031-.019l.074-.043a2.465 2.465 0 0 0 1.141-2.09V49.11a8.23 8.23 0 0 0-4.188-7.173l.006.006Z"
    />
    <path
      fill="#fff"
      d="M80.579 33.29v39.64c0 .901.487 1.734 1.277 2.172L116.5 94.327c1.653.919 3.688-.278 3.688-2.171V54.119c0-1.659-.894-3.195-2.343-4.015L84.28 31.126c-1.653-.938-3.707.259-3.707 2.165"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M80.579 33.29v39.64c0 .901.487 1.734 1.277 2.172L116.5 94.327c1.653.919 3.688-.278 3.688-2.171V54.119c0-1.659-.894-3.195-2.343-4.015L84.28 31.126c-1.653-.938-3.707.259-3.707 2.165h.006Z"
    />
    <path
      fill="#fff"
      d="M108.124 58.684c3.121 6.877 1.739 14.222-3.078 16.412-4.823 2.19-11.262-1.61-14.383-8.487-3.12-6.877-1.74-14.223 3.078-16.412 4.817-2.19 11.262 1.61 14.383 8.486Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M108.124 58.684c3.121 6.877 1.739 14.222-3.078 16.412-4.823 2.19-11.262-1.61-14.383-8.487-3.12-6.877-1.74-14.223 3.078-16.412 4.817-2.19 11.262 1.61 14.383 8.486Z"
    />
    <path
      fill="#fff"
      d="M118.961 45.626a4.16 4.16 0 0 1-4.157-4.157V18.402c0-3.794-1.209-6.865-3.072-7.827-2.751-1.419-5.649-1.653-7.383-.599-1.93 1.178-2.337 3.979-2.337 6.119v13.113a4.16 4.16 0 0 1-4.157 4.157 4.159 4.159 0 0 1-4.157-4.157V16.095c0-8.148 3.966-11.78 6.328-13.218 4.28-2.609 10.084-2.491 15.518.309 4.749 2.442 7.58 8.135 7.58 15.216v23.067a4.159 4.159 0 0 1-4.157 4.157"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M118.961 45.626a4.16 4.16 0 0 1-4.157-4.157V18.402c0-3.794-1.209-6.865-3.072-7.827-2.751-1.419-5.649-1.653-7.383-.599-1.93 1.178-2.337 3.979-2.337 6.119v13.113a4.16 4.16 0 0 1-4.157 4.157 4.159 4.159 0 0 1-4.157-4.157V16.095c0-8.148 3.966-11.78 6.328-13.218 4.28-2.609 10.084-2.491 15.518.309 4.749 2.442 7.58 8.135 7.58 15.216v23.067a4.159 4.159 0 0 1-4.157 4.157h-.006Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M101.815 62.39c0-1.443-1.437-3.318-3.127-4.002-1.326-.543-2.381-.111-2.48.999-.086.95.518 2.134 1.431 3.04v3.547c0 .345.32.79.722.987l1.301.654c.395.197.722.08.722-.266v-3.546c.857.012 1.437-.494 1.437-1.413"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M101.815 62.39c0-1.443-1.437-3.318-3.127-4.002-1.326-.543-2.381-.111-2.48.999-.086.95.518 2.134 1.431 3.04v3.547c0 .345.32.79.722.987l1.301.654c.395.197.722.08.722-.266v-3.546c.857.012 1.437-.494 1.437-1.413h-.006Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M33.303 64.938 7.83 50.536a1.911 1.911 0 0 0-1.98.055l-.012-.012-4.422 2.887.586 3.663 2.954 31.086c0 1.4.752 2.689 1.967 3.38l21.958 12.477-1.006 1.702 1.66 3.319 4.89-3.078v-.019c.506-.339.858-.906.858-1.603V68.311a3.89 3.89 0 0 0-1.974-3.386"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M33.303 64.938 7.83 50.536a1.911 1.911 0 0 0-1.98.055l-.012-.012-4.422 2.887.586 3.663 2.954 31.086c0 1.4.752 2.689 1.967 3.38l21.958 12.477-1.006 1.702 1.66 3.319 4.89-3.078v-.019c.506-.339.858-.906.858-1.603V68.311a3.89 3.89 0 0 0-1.974-3.386l-.006.013Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M.342 55.162v36.007c0 1.4.753 2.69 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.678V71.272a3.89 3.89 0 0 0-1.973-3.386L3.223 53.484c-1.283-.728-2.874.203-2.874 1.678"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M.342 55.162v36.007c0 1.4.753 2.69 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.678V71.272a3.89 3.89 0 0 0-1.973-3.386L3.223 53.484c-1.283-.728-2.874.203-2.874 1.678H.342Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M84.989 95.296 59.516 80.894a1.912 1.912 0 0 0-1.98.055l-.012-.012-4.422 2.886.586 3.664 2.954 31.086c0 1.4.752 2.689 1.967 3.38l21.958 12.477-1.006 1.702 1.66 3.319 4.89-3.078v-.019c.506-.339.858-.906.858-1.603V98.669a3.89 3.89 0 0 0-1.974-3.386"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M84.989 95.296 59.516 80.894a1.912 1.912 0 0 0-1.98.055l-.012-.012-4.422 2.886.586 3.664 2.954 31.086c0 1.4.752 2.689 1.967 3.38l21.958 12.477-1.006 1.702 1.66 3.319 4.89-3.078v-.019c.506-.339.858-.906.858-1.603V98.669a3.89 3.89 0 0 0-1.974-3.386l-.006.013Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M52.028 85.52v36.007c0 1.4.753 2.689 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.678V101.63a3.89 3.89 0 0 0-1.974-3.386L54.908 83.842c-1.282-.728-2.874.204-2.874 1.678"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M52.028 85.52v36.007c0 1.4.753 2.689 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.678V101.63a3.89 3.89 0 0 0-1.974-3.386L54.908 83.842c-1.282-.728-2.874.204-2.874 1.678h-.006Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m136.675 125.647-25.473-14.402a1.912 1.912 0 0 0-1.98.056l-.012-.012-4.423 2.886.586 3.664 2.955 31.085c0 1.4.752 2.689 1.967 3.38l21.957 12.478-1.005 1.702 1.659 3.318 4.891-3.078v-.018c.506-.339.858-.907.858-1.604v-36.081c0-1.4-.753-2.695-1.974-3.386"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m136.675 125.647-25.473-14.402a1.912 1.912 0 0 0-1.98.056l-.012-.012-4.423 2.886.586 3.664 2.955 31.085c0 1.4.752 2.689 1.967 3.38l21.957 12.478-1.005 1.702 1.659 3.318 4.891-3.078v-.018c.506-.339.858-.907.858-1.604v-36.081c0-1.4-.753-2.695-1.974-3.386l-.006.012Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M103.714 115.877v36.007c0 1.401.753 2.69 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.677v-36.082a3.89 3.89 0 0 0-1.973-3.386l-25.473-14.402c-1.283-.727-2.874.204-2.874 1.678"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M103.714 115.877v36.007c0 1.401.753 2.69 1.968 3.38l25.479 14.482c1.283.728 2.88-.197 2.88-1.677v-36.082a3.89 3.89 0 0 0-1.973-3.386l-25.473-14.402c-1.283-.727-2.874.204-2.874 1.678h-.007Z"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      className="gray-element"
      d="M17.612 82.7c.228-.06.45-.147.66-.27 2.079-1.203 2.128-5.021.099-8.524-2.023-3.51-5.354-5.379-7.432-4.176-2.079 1.203-2.122 5.02-.1 8.53.174.296.352.574.537.845-5.785-1.27-6.414 6.303-6.414 6.303l18.503 10.825s.704-7.648-5.847-13.526"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M17.612 82.7c.228-.06.45-.147.66-.27 2.079-1.203 2.128-5.021.099-8.524-2.023-3.51-5.354-5.379-7.432-4.176-2.079 1.203-2.122 5.02-.1 8.53.174.296.352.574.537.845-5.785-1.27-6.414 6.303-6.414 6.303l18.503 10.825s.704-7.648-5.847-13.526l-.006-.006Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M70.39 112.238c.228-.061.45-.148.66-.271 2.078-1.203 2.128-5.021.099-8.524-2.024-3.51-5.354-5.378-7.433-4.176-2.078 1.203-2.121 5.021-.098 8.53.172.29.351.574.536.845-5.785-1.27-6.414 6.304-6.414 6.304l18.503 10.824s.703-7.648-5.847-13.526"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M70.39 112.238c.228-.061.45-.148.66-.271 2.078-1.203 2.128-5.021.099-8.524-2.024-3.51-5.354-5.378-7.433-4.176-2.078 1.203-2.121 5.021-.098 8.53.172.29.351.574.536.845-5.785-1.27-6.414 6.304-6.414 6.304l18.503 10.824s.703-7.648-5.847-13.526l-.006-.006Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M122.625 142.867c.228-.061.45-.148.66-.271 2.078-1.203 2.127-5.021.098-8.524-2.023-3.509-5.353-5.378-7.432-4.176-2.078 1.203-2.122 5.021-.099 8.531.173.289.352.573.537.845-5.785-1.271-6.415 6.303-6.415 6.303l18.504 10.824s.703-7.648-5.847-13.525"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M122.625 142.867c.228-.061.45-.148.66-.271 2.078-1.203 2.127-5.021.098-8.524-2.023-3.509-5.353-5.378-7.432-4.176-2.078 1.203-2.122 5.021-.099 8.531.173.289.352.573.537.845-5.785-1.271-6.415 6.303-6.415 6.303l18.504 10.824s.703-7.648-5.847-13.525l-.006-.007Z"
    />
  </svg>
)
export default SvgComponent
